import styled from "styled-components";

export const DashboardContainer = styled.div`
  background: #f3f7ff;
  margin-left: 255px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: hidden;

  @media (max-width: 768px) {
    margin-left: 0px;
  }

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const DashboardWrapper = styled.div`
  display: flex;
  z-index: 1;
  height: calc(100vh - 80px);
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  overflow: overlay;
`;

export const ProfileDetailForm = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const Button = styled.button`
  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FAFAFA ;
  border: 1px solid #21212126
`;

export const DeleteButton = styled.button`
  border-radius: 2px;
  background: #F03434;
  color: #ffffff;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
`;

export const DashboardHeading = styled.div`
   font-family: "Roboto";
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;

  @media screen and (max-width: 880px) {
    font-size: 18px;
  }

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;


export const ServiceDetailForm = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.8rem;

  @media screen and (max-width: 955px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

export const SearchFilterContainer = styled.div`
  width: 100%;
  background: rgba(255, 255, 255, 1);
  padding: 0.8rem;
  /* display: flex; */
  align-items: center;
  /* justify-content: space-between; */
  border: 1px solid rgba(38, 52, 78, 0.15);
  border-radius: 4px;

  @media screen and (max-width: 955px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

export const SelectedColumnContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const DashHeading = styled.div`
  font-family: "Roboto";
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  color: #264503;

  @media screen and (max-width: 880px) {
    font-size: 18px;
  }

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const DashCard = styled.div`
  height: auto;
  // width: auto;
  display: flex;
  font-size: 17px;
  padding: 10px 15px;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  margin-bottom: 15px;
  box-shadow: 0px 2px 2px #00000012;
  color: #1a1a1a;
`;

export const DashContainerCard = styled.div`
  // background-color: pink;
  height: auto;
  width: 80%;
  padding: 20px 20px;
  display: grid;
  margin-left: 1.5rem;
  grid-template-columns: auto auto auto auto;
  grid-gap: 14px 25px;

  @media screen and (max-width: 1290px) {
    display: flex;
    flex-direction: column;
  }
`;

export const HeadingButton = styled.div``;

export const DashContentCard = styled.div`
  height: auto;
  width: 320px;
  display: flex;
  font-size: 17px;
  padding: 15px;
  background-color: #ffffff;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0px 2px 2px lightgrey;
  color: #1a1a1a;

  @media screen and (max-width: 1590px) {
    width: 300px;
  }

  @media screen and (max-width: 425px) {
    width: 335px;
  }

  @media screen and (max-width: 375px) {
    width: 300px;
  }

  @media screen and (max-width: 320px) {
    width: 250px;
  }
`;
export const DashContainerCardIcon = styled.div`
  height: auto;
  width: auto;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  padding: 0.8rem 0rem;
  color: white;
`;

export const DashIcon = styled.img`
  height: auto;
  width: 50%;
  padding: 14px;
`;

export const DashContainerCardContent = styled.div`
  height: auto;
  width: 65%;
  margin: auto;
  // background-color: lightcyan;
`;

export const DashContainerCardContentTotal = styled.p`
  color: #808080;
  font: normal normal normal 11px/24px Lato;
  letter-spacing: 0.11px;
`;

export const DashContainerCardContentNumber = styled.p`
  color: #000000;
  font: normal normal bold 20px/24px Lato;
  letter-spacing: 0.2px;
`;

export const DashContainerCardContentOrder = styled.p`
  color: #404040;
  font: normal normal normal 14px/24px Lato;

  letter-spacing: 0.42px;
`;

export const DashContent = styled.p`
  height: auto;
  width: 97%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: #1a1a1a;
  padding: 0 10px;
  font-size: 1.3rem;
  // margin-left: 2rem;
`;

export const Filter = styled.div`
background-color: #88AE40;
color:white;
padding:12px;
margin-left:1rem;
`;

export const DpBox = styled.div`
position:absolute;
top: 175px;
right:50px;
width:350px;
border-radius: 8px;
background: #FFF;
box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.10);
z-index: 9999;
`;

export const Fields = styled.div`
border-top:2px solid #D9E3D9;
border-bottom:2px solid #D9E3D9;
`;

export const Resetbtn = styled.div`
border-radius: 4px;
background: rgba(80, 101, 57, 0.10);
padding:12px 20px;
cursor:pointer;
color:#264503;
`;

export const Applybtn = styled.div`
padding:12px 20px;
border-radius: 4px;
background: #264503;
cursor:pointer;

`;